import { ConfigurationSourceDataMap, Institution, Metadata, Participant, MasterGroup, CoordinatingGroup, SourceData, Trial, UpdateStatusEvent, SourceDataStatus } from "@/api/dtos";
import IsLoading from "@/components/layouts/IsLoading";
import Show from "@/components/layouts/Show";
import ParticipantSourceDataEventStatusList, { ParticipantSourceDataEventStatusListItemType } from "@/components/lists/status/ParticipantSourceDataEventStatusList";
import ParticipantSourceDataEventStatusesContext from "@/contexts/data/ParticipantSourceDataEventStatusesContext";
import SourceDataFormContext from "@/contexts/form/SourceDataFormContext";
import useParticipantSourceDataEventStatuses from "@/hooks/data/useParticipantSourceDataEventStatuses";
import useStatusUpdate from "@/hooks/data/useStatusUpdate";
import useEvent from "@/hooks/form/source-data/useEvent";
import useEvents from "@/hooks/form/source-data/useEvents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, AlertTitle, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper } from "@mui/material";
import { FC, useCallback, useMemo, useContext } from "react";
import { Link } from "react-router-dom";

interface ISourceDataEventsProps {
    trial: Trial;
    masterGroup?: MasterGroup;
    coordinatingGroup?: CoordinatingGroup;
    institution?: Institution;
    participant: Participant;
    metadata: Metadata;
    trialConfiguration: ConfigurationSourceDataMap;
    configuration: ConfigurationSourceDataMap;
    sourceData: SourceData;
    preview?: boolean;
}

const SourceDataEvents: FC<ISourceDataEventsProps> = ({
    trial,
    masterGroup,
    coordinatingGroup,
    institution,
    participant,
    metadata,
    trialConfiguration,
    configuration,
    sourceData,
    preview
}) => {
    const { data: statuses, refresh: statusesRefresh } = useContext(ParticipantSourceDataEventStatusesContext);
    const {  queueUpdate} = useContext(SourceDataFormContext);
    
    const statusMapping = useMemo(() => {
        return statuses?.reduce<Record<number, SourceDataStatus>>((a, b) => {
            if (!b?.studyEventOid || !b?.studyEventRepeat) {
                return a;
            }
            
            a[`${b.studyEventOid}-${b.studyEventRepeat}` as any] = b;

            return a;
        }, {})
    }, [statuses])

    const eventData = useEvents(
        metadata,
        trialConfiguration,
        configuration,
        sourceData,
        trial,
        masterGroup,
        coordinatingGroup,
        institution,
        participant,
        preview
    );

    return (
        <>
            <ParticipantSourceDataEventStatusList 
                trial={trial}
                institution={institution}
                participant={participant}
                data={eventData}
                statuses={statusMapping}
                queueUpdate={queueUpdate}
            />
        </>
    )
};

export default SourceDataEvents;